export default __webpack_public_path__ + "static/media/F0004.6dda1aff.png";